import React, {useCallback, useLayoutEffect, useRef} from 'react'
import {findDOMNode} from "react-dom"

import {InternalLinkOption} from "../../option"
import VScroll from "../../../../../scrolling/custom-v-scroll/v-scroll"
import {PopoverMenuItemType} from "../../../../../popover-menu/popover-menu/const"
import PopoverMenuHeader from "../../../../../popover-menu/popover-menu/popover-menu-header"
import PopoverMenuSeparator from "../../../../../popover-menu/popover-menu/popover-menu-separator"
import SlashDefaultMenuOptions from "./menu-options"

type RenderGroup = {
    header?     : InternalLinkOption
    options     : InternalLinkOption[]
    separator?  : InternalLinkOption
}

type Props = {
    selectedIndex   : number | null
    options         : InternalLinkOption[]

    onClick         : {(index:number, option:InternalLinkOption): void}
}

const debug = false
// const debug = "SlashDefaultMenu"

export default function SlashDefaultMenu (props: Props) {
    const scrollRef: any            = useRef()

    const getScrollContainerNode = useCallback(() => {
        return findDOMNode(scrollRef.current)?.childNodes[1]
    }, [scrollRef.current])

    const setScrollTop    = useCallback((scrollValue: any) => {
        if (!_.isNil(scrollValue)) {
            scrollRef.current?.setScrollTop(scrollValue, false, 100)
        }
    }, [scrollRef.current])

    const selectedId = props.selectedIndex ? props.options[props.selectedIndex]?.id : undefined

    useLayoutEffect(() => {
        const scrollContainerNode   : any   = getScrollContainerNode()
        const selectedNode          : any   = selectedId ? document.getElementById(selectedId) : null

        if (selectedNode && scrollContainerNode) {
            const selectedOptionTop     = selectedNode.offsetTop
            const selectedOptionBottom  = selectedNode.offsetTop + selectedNode.clientHeight
            const scrollTop             = scrollContainerNode.scrollTop
            const scrollBottom          = scrollContainerNode.scrollTop + scrollContainerNode.clientHeight

            // set scroll value if selected option is outside scroll visible area
            let scrollValue
            if (selectedOptionTop < scrollTop) {
                scrollValue = selectedOptionTop
            } else if (selectedOptionBottom > scrollBottom) {
                scrollValue = selectedOptionBottom - scrollContainerNode.clientHeight
            }

            setScrollTop(scrollValue)
        }
    }, [props.selectedIndex])

    const lastOptionKey = props.options.length - 1

    const renderGroups: RenderGroup[] = []
    let group: any

    _.map(props.options, (option, key)=>{
        switch (option.type) {
            case PopoverMenuItemType.HEADER     :
                // start new group
                group = {
                    header  : option,
                    options : []
                }
                break

            case PopoverMenuItemType.SEPARATOR  :
                if (group) {
                    group.separator = option
                    // add group to array
                    renderGroups.push(group)
                }
                break

            default                             :
                group?.options.push(option)
        }

        // add last group if no more options
        if (lastOptionKey === key) {
            renderGroups.push(group)
        }
    })

    debug && console.log(debug, 'render', selectedId, props.selectedIndex, renderGroups)

    return (
        <div className="ui5-popover-menu">
            <VScroll ref={scrollRef} containerStyle={{width:420, maxHeight:350}}>
                {_.map(renderGroups, (group, key)=>{

                    const length        = Math.ceil(group.options.length / 2)
                    const leftOptions   = _.slice(group.options, 0, length)
                    const rightOptions  = _.slice(group.options, length)

                    return (
                        <React.Fragment key={key}>
                            {group.header && <PopoverMenuHeader title={group.header.label}/>}

                            <div className="flex-row-left-top">
                                <div className="flex-column-left-top w-100-percent p-h-5 border-box">
                                    <SlashDefaultMenuOptions options        = {leftOptions}
                                                             selectedId     = {selectedId}
                                                             onClick        = {props.onClick}/>
                                </div>

                                <div className="flex-column-left-top w-100-percent p-h-5 border-box">
                                    <SlashDefaultMenuOptions options        = {rightOptions}
                                                             selectedId     = {selectedId}
                                                             onClick        = {props.onClick}/>
                                </div>
                            </div>

                            {group.separator && <PopoverMenuSeparator key={key}/>}
                        </React.Fragment>
                    )
                })}
            </VScroll>
        </div>
    )
}
